// removed by extract-text-webpack-plugin
module.exports = {"joinUsContainer":"Register__joinUsContainer___2vAJG","joinUsBanner":"Register__joinUsBanner___3dpjl","joinUsDetails":"Register__joinUsDetails___2g_8J"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/Register.scss
// module id = 1584
// module chunks = 0